/**
 * @module
 * @description
 * Entry point for all public APIs of ng2-json-editor module.
 */
export * from './src/index';
